import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, compose, branch, withHandlers, renderComponent, withState } from 'recompose'
import { CtaTypes } from 'app/modules/playbook/constants'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import * as UserSelectors from 'app/modules/user/selectors'

import TargetedMessage, { TargetMessageLoading } from './component'

const mapStateToProps = state => ({
  theme: EmbedSelectors.theme(state),
  defaultEmbed: EmbedSelectors.getEmbedConfig(state),
  embedFetchPending: EmbedSelectors.embedFetchPending(state),
  orgUsers: UserSelectors.currentOrgUsersAlphabetical(state),
  targetedMessage: PlaybookSelectors.targetedMessage(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setMessage: PlaybookActions.setMessage,
      setHeadline: PlaybookActions.setHeadline,
      setCtaLink: PlaybookActions.setCtaLink,
      setCtaCopy: PlaybookActions.setCtaCopy,
      setAuthorId: PlaybookActions.setAuthorId,
      savePlaybookFailed: PlaybookActions.savePlaybookFailed,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(props => !props.theme || props.embedFetchPending || !props.orgUsers.size, renderComponent(TargetMessageLoading)),
  withProps(props => ({
    userObjForAuthor: props.orgUsers.toJS().find(user => user.id === props.targetedMessage.authorId),
  })),
  withProps(props => ({
    message: props.targetedMessage.message,
    headline: props.targetedMessage.title,
    hideCta: !props.targetedMessage.cta || _.get(props.targetedMessage, 'cta.type', CtaTypes.CHAT) === CtaTypes.NONE,
    ctaCopy: _.get(props.targetedMessage, 'cta.copy'),
    ctaLink: _.get(props.targetedMessage, 'cta.url'),
    selectedUser: props.userObjForAuthor || props.orgUsers.first().toJS(),
  })),
  withState('headlineInvalid', 'setHeadlineInvalid', props => !props.headline || !props.headline.trim()),
  withHandlers({
    onMessageChange: props => message => {
      props.actions.setMessage(message)
    },
    onHeadlineChange: props => event => {
      const isInvalid = !event.target.value || !event.target.value.trim()
      if (isInvalid) {
        props.actions.savePlaybookFailed()
        props.setHeadlineInvalid(true)
      } else {
        props.setHeadlineInvalid(false)
      }
      props.actions.setHeadline({ value: event.target.value, dontSave: isInvalid })
    },
    onAuthorChange: props => ({ value }) => {
      props.actions.setAuthorId(value)
    },
  })
)(TargetedMessage)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetedMessage/index.js